import { escapeHtml } from "../utils/escapeHtml";

interface DrilldownAsset {
  id: string;
  name: string;
  ean: string;
  booked: boolean;
}

interface DrilldownOptions {
  project: string;
  hub: string;
  booked: number;
  preForecast: number;
  assets: DrilldownAsset[];
  anchorEl: HTMLElement;
  onValidateAsset: (assetId: string) => void;
}

export function showCellDrilldown(opts: DrilldownOptions): void {
  closeCellDrilldown();

  const popover = document.createElement("div");
  popover.className = "cell-drilldown";

  // Position relative to anchor
  const rect = opts.anchorEl.getBoundingClientRect();
  popover.style.position = "fixed";
  popover.style.top = `${rect.bottom + 4}px`;
  popover.style.left = `${Math.max(8, rect.left - 100)}px`;

  const assetRows = opts.assets.length
    ? opts.assets.map((a) => `<tr>
        <td style="padding:3px 6px;color:var(--ink)">${escapeHtml(a.name)}</td>
        <td style="padding:3px 6px;color:var(--muted);font-size:0.7rem">${escapeHtml(a.ean)}</td>
        <td style="padding:3px 6px">${a.booked
          ? `<span style="color:#10b981;font-size:0.7rem">✓ BOOKED</span>`
          : `<span class="drilldown-validate" data-drilldown-asset="${escapeHtml(a.id)}" style="color:var(--accent);cursor:pointer;font-size:0.7rem">⊕ VALIDATE</span>`
        }</td>
      </tr>`).join("")
    : `<tr><td colspan="3" style="padding:8px;color:var(--muted);text-align:center">No asset details available</td></tr>`;

  popover.innerHTML = `
    <div class="cell-drilldown-header">
      <strong>${escapeHtml(opts.project)}</strong> — ${escapeHtml(opts.hub)} <span style="color:var(--muted);font-weight:400;font-size:0.8rem">(${opts.booked.toLocaleString()} forecasted / ${opts.preForecast > 0 ? opts.preForecast.toLocaleString() : "—"} planned)</span>
      <button class="cell-drilldown-close" type="button">✕</button>
    </div>
    <table style="width:100%;border-collapse:collapse;font-size:0.75rem">
      <tr style="border-bottom:1px solid var(--line)">
        <th style="padding:3px 6px;color:var(--muted);text-align:left">Asset</th>
        <th style="padding:3px 6px;color:var(--muted);text-align:left">EAN</th>
        <th style="padding:3px 6px;color:var(--muted);text-align:left">Status</th>
      </tr>
      ${assetRows}
    </table>
  `;

  // Close button
  popover.querySelector(".cell-drilldown-close")?.addEventListener("click", closeCellDrilldown);

  // Validate clicks
  popover.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-drilldown-asset]");
    if (btn) opts.onValidateAsset(btn.dataset.drilldownAsset || "");
  });

  document.body.appendChild(popover);

  // Close on click outside (delayed to avoid immediate close)
  setTimeout(() => {
    const handler = (e: MouseEvent) => {
      if (!popover.contains(e.target as Node)) {
        closeCellDrilldown();
        document.removeEventListener("click", handler);
      }
    };
    document.addEventListener("click", handler);
  }, 100);
}

export function closeCellDrilldown(): void {
  document.querySelector(".cell-drilldown")?.remove();
}
